export default __webpack_public_path__ + "static/media/Belt of the Unslaked.8dfa40c6.jpg";